import { Construtor } from './construtor';
import { Funcionalidade } from './funcionalidade';

export class GrupoAcessoPermissaoFuncionalidade implements Construtor<GrupoAcessoPermissaoFuncionalidade> {

  public idGrupoAcessoPermissaoFuncionalidade: number;
  public idGrupoAcesso: number;
  public funcionalidade: Funcionalidade;
  public alterar: boolean;
  public visualizar: boolean;

  constructor(object?: any) {
    this.funcionalidade = new Funcionalidade();
    if (object !== undefined) {

      if (object instanceof GrupoAcessoPermissaoFuncionalidade) {
        this.copyObject(object);
      } else if (object instanceof Funcionalidade) {
        this.funcionalidade = new Funcionalidade(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  copyObject(grupoAcessoPermissao: GrupoAcessoPermissaoFuncionalidade): void {
    this.idGrupoAcessoPermissaoFuncionalidade = grupoAcessoPermissao.idGrupoAcessoPermissaoFuncionalidade;
    this.idGrupoAcesso = grupoAcessoPermissao.idGrupoAcesso;
    this.funcionalidade = grupoAcessoPermissao.funcionalidade;
    this.alterar = grupoAcessoPermissao.alterar;
    this.visualizar = grupoAcessoPermissao.visualizar;
  }

  parseFromJson(grupoAcessoPermissao: any): void {
    this.idGrupoAcessoPermissaoFuncionalidade = grupoAcessoPermissao.idGrupoAcessoPermissaoFuncionalidade;
    this.idGrupoAcesso = grupoAcessoPermissao.idGrupoAcesso;
    this.funcionalidade = grupoAcessoPermissao.funcionalidade;
    this.alterar = grupoAcessoPermissao.alterar;
    this.visualizar = grupoAcessoPermissao.visualizar;
  }

  modeloCompleto(): boolean {
    return this.idGrupoAcesso !== undefined;
  }

  getNewInstance(object?: any): GrupoAcessoPermissaoFuncionalidade {
    return new GrupoAcessoPermissaoFuncionalidade(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/grupo-acesso-permissao-funcionalidade.ts